import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { setDealerSession } from "@/lib/dealerAuth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function DealerLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${BACKEND_URL}/api/dealer/login`, { email, password });
      // Persist in localStorage (Phase 7 hotfix — was sessionStorage which
      // dropped the session on new tab / hard refresh).
      setDealerSession(res.data.token, res.data.dealer);
      toast.success(`Üdvözöljük, ${res.data.dealer.full_name}!`);
      navigate("/dealer/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Hibás email vagy jelszó");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#030303] text-white flex flex-col">
      {/* Header */}
      <div className="border-b border-white/5 px-4 py-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/alpine-car-logo.png" alt="Alpine Car" className="w-10 h-10 rounded-lg object-cover" />
            <span className="font-bold text-lg">Alpine Car</span>
          </Link>
          <Link to="/dealer-register" className="text-sm text-[#D4AF37] hover:underline" data-testid="register-link">
            Regisztráció
          </Link>
        </div>
      </div>

      {/* Login form */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/20 mb-4">
              <svg className="w-4 h-4 text-[#D4AF37]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <span className="text-xs text-[#D4AF37] font-medium">Kereskedői felület</span>
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold mb-2">Bejelentkezés</h1>
            <p className="text-white/50 text-sm">Kereskedői fiókkal való belépés</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="dealer-login-form">
            <div>
              <label className="block text-xs text-white/60 mb-1.5">Email cím</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="kereskedő@ceg.hu"
                className="w-full bg-[#111] border border-white/10 rounded-lg px-4 py-3 text-sm focus:border-[#D4AF37] focus:outline-none transition-colors"
                data-testid="input-email"
              />
            </div>
            <div>
              <label className="block text-xs text-white/60 mb-1.5">Jelszó</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="Jelszó"
                className="w-full bg-[#111] border border-white/10 rounded-lg px-4 py-3 text-sm focus:border-[#D4AF37] focus:outline-none transition-colors"
                data-testid="input-password"
              />
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-[#D4AF37] text-black font-semibold py-3.5 rounded-lg hover:bg-[#c4a030] disabled:opacity-50 transition-colors"
              data-testid="submit-login">
              {loading ? "Bejelentkezés..." : "Bejelentkezés"}
            </button>
          </form>

          <p className="text-center text-sm text-white/40 mt-6">
            Nincs még fiókja? <Link to="/dealer-register" className="text-[#D4AF37] hover:underline">Regisztráció</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
